import {useMutation} from "react-query";
import {CreateResidentDto} from "../types";
import {ResidentService} from "../../../services/ResidentServices";
import Alert from "react-s-alert";
import {useNavigate} from "react-router-dom";

export const useEditResident = (resident_uuid: string) => {
  const navigate = useNavigate();

  return useMutation(
    async (body: CreateResidentDto) => {
      return await ResidentService.editResident(body, resident_uuid);
    },
    {
      onSuccess: () => {
        Alert.success("Resident successfully updated!");
        navigate(`/admin/residents/${resident_uuid}`);
      },
      onError: (err: any) => {
        Alert.error(
          err?.data?.detail ? err?.data?.detail : "Something went wrong",
        );
      },
    },
  );
};
